const animationConfig = {
    direction: "normal",
    duration: 233,
    easing: "ease-out",
    fill: "forwards",
};
function animations(direction = "direct", stagedOffset = 150) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const slidePadding = stagedOffset * 0.1;
    const stagedOffsetWithSlide = Math.floor(stagedOffset + slidePadding);
    return {
        active: {
            keyframes: [
                {
                    offset: 0,
                    opacity: 1,
                    transform: `translateX(${direction === "previous"
                        ? `-${stagedOffset}px`
                        : `${stagedOffset}px`}) scale(0.9)`,
                    zIndex: 3,
                },
                {
                    offset: 1,
                    opacity: 1,
                    transform: "translateX(0px) scale(1)",
                    zIndex: 3,
                },
            ],
            config: animationConfig,
        },
        hidden: {
            keyframes: [
                {
                    offset: 0,
                    opacity: 0,
                    zIndex: 1,
                },
                {
                    offset: 1,
                    opacity: 0,
                    zIndex: 1,
                },
            ],
            config: {
                ...animationConfig,
                duration: 50,
            },
        },
        pre: {
            keyframes: [
                {
                    offset: 0,
                    opacity: String(direction === "previous" ? "0.3" : "1"),
                    transform: `translateX(${direction === "previous" ? `-${stagedOffsetWithSlide}px` : "0px"}) scale(${direction === "previous" ? "0.8" : "1"})`,
                    zIndex: 2,
                },
                {
                    offset: 1,
                    opacity: 1,
                    transform: `translateX(-${stagedOffset}px) scale(0.8)`,
                    zIndex: 2,
                },
            ],
            config: animationConfig,
        },
        post: {
            keyframes: [
                {
                    offset: 0,
                    opacity: 0.3,
                    transform: `translateX(${direction === "previous" ? "0px" : `${stagedOffsetWithSlide}px`}) scale(${direction === "previous" ? "1" : "0.8"})`,
                    zIndex: 2,
                },
                {
                    offset: 1,
                    opacity: 1,
                    transform: `translateX(${stagedOffset}px) scale(0.8)`,
                    zIndex: 2,
                },
            ],
            config: animationConfig,
        },
    };
}
export { animations };
